import { API_URL } from "../../config/connect";
import { getCurrentBackendLanguage } from "../../utils/apiErrorHandler";

export async function deleteMessage(messageId) {
  const endpoint = `${API_URL}/api/v1/chat/message/${messageId}`;

  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) {
    throw new Error("Access token is missing");
  }

  const response = await fetch(endpoint, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Accept-Language': getCurrentBackendLanguage(),
    },
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }

  return response.json();
}